import { render } from "../income_estimator/income_estimator.html?vue&type=template&id=5cbee439&external"
import script from "../income_estimator/income_estimator.js?vue&type=script&lang=js&external"
export * from "../income_estimator/income_estimator.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__